import {NavigationService} from '../../Services/NavigationService';
import {TimeEntryDataService} from '../../Services/TimeEntryDataService';
import {EntryQueueService} from '../../Services/EntryQueueService';
import {EExternalProjectType, EKind, EStampType, IEmployeeVm, ITimeEntryTypeVm, ProxyContainer} from '../../Data/Data';
import {TimeEntryDialog} from '../../Models/time-entry-dialog';
import {TimeQueueItem} from '../../Services/TimeQueueItem';
import {ScannerService} from '../../Services/ScannerService';
import * as angular from 'angular';
import {ConfirmDialog} from "../../Models/confirm-dialog";
import {TerminalSessionService} from "../../Services/TerminalSessionService";

export class StartController {
  static controllerId = 'StartController';
  static $inject = [
    NavigationService.serviceId,
    '$stateParams',
    TimeEntryDataService.serviceId,
    EntryQueueService.serviceId,
    ScannerService.serviceId,
    TerminalSessionService.serviceId,
    '$scope',
    '$proxy'
  ];

  person: IEmployeeVm;

  selectedType: ITimeEntryTypeVm;
  selectedProjectType: number = EExternalProjectType.Proj;

  confirmDialog = new ConfirmDialog();
  timeEntryDialog = new TimeEntryDialog();
  kind: EKind = EKind.Work;
  projectId: number;
  positionNr: number | null = null;

  canScanPosition = false;

  warningMessage = '';

  projKinds = [EKind.Work];

  constructor(private nav: NavigationService,
              private params,
              private timeEntryData: TimeEntryDataService,
              private queue: EntryQueueService,
              private scanner: ScannerService,
              private terminalSession: TerminalSessionService,
              private $scope: angular.IScope,
              private proxy: ProxyContainer) {

    this.person = this.params.person;

    const init = this.initType();

    if (!this.person) {
      this.goBack();
      return;
    }

    this.canScanPosition = this.person.claims.some(c => c === 'marina_bookings');

    init.then(() => this.scanProjectNo())
      .then(() => {
        //Wenn keine Leistungsart gewählt werden kann, wird direkt gebucht.
        if (!this.canSelectType() && !this.canScanPosition) {
          return this.confirm();
        }
      });
  }

  private async initType() {
    const id = this.terminalSession.getDefaultEntryTypeId();
    if (id == null) {
      this.selectedType = await this.timeEntryData.getDefault(this.kind);
    } else {
      this.selectedType = await this.timeEntryData.getEntryType(id);
    }
  }

  goBack() {
    this.nav.goToMenu();
  }

  canSelectType() {
    return this.terminalSession.canSelectType();
  }

  openTimeEntryDialog() {
    this.timeEntryDialog.open(val => {
      this.selectedType = val;
    });
  }

  projChange() {
    this.warningMessage = '';
  }

  async scanPositionNo() {
    const result = await this.scanner.scanPosition();

    if (result && result.value) {
      this.positionNr = result.value;
    } else {
      this.positionNr = null;
    }
  }

  async scanProjectNo() {
    const result = await this.scanner.scanProject();

    if (result) {
      this.$scope.$apply(() => {
        this.projectId = result.value;
        this.selectedProjectType = result.type;

        if (result.value) {
          this.proxy.Project.exists({
            type: result.type,
            externalNr: result.value.toString(),
          }).then(response => {
            if (!response.data) {
              this.warningMessage = 'Projekt nicht gefunden';
            } else {
              this.warningMessage = '';
            }
          }, () => {
            this.warningMessage = '';
          });
        }
      });
    }
  }

  confirm(): null | Promise<void> {
    if (!this.projectId || !this.selectedType) {
      return;
    }

    this.queue.enqueue(new TimeQueueItem(this.selectedType.id,
      this.projectId, this.selectedProjectType,this.person.id, new Date(), EStampType.Start, null, this.positionNr));

    return this.confirmDialog.open('Buchung gesendet', false, 2000).then(() => {
      this.goBack();
      this.terminalSession.logout();
    });
  }

}
